
export default {
  name: 'ResultsEmpty',

  props: {
    context: {
      type: String,
      required: true
    }
  },
  computed: {
    imagePath() {
      if (this.context === 'applications') {
        return require(`@/resources/images/no-applications.svg`)
      } else if (this.context === 'invitations') {
        return require(`@/resources/images/no-invitations.svg`)
      } else {
        return ''
      }
    },
    texts() {
      switch (this.context) {
        case 'applications':
          return {
            header: this.$t('talent.project.search.applications.empty'),
            description: this.$t('talent.project.search.applications.empty.description')
          }
        case 'invitations':
          return {
            header: this.$t('talent.project.search.invitations.empty'),
            description: this.$t('talent.project.search.invitations.empty.description')
          }
        default:
          return {
            header: this.$t('talent.project.search.search.empty'),
            description: this.$t('talent.project.search.search.empty.description')
          }
      }
    }
  }
}
